import { Typography } from "@mui/material";

import StyledProPage from "../StyledPage";

interface Props {
  handleNext: () => void;
  handleBack?: () => void;
  nextLoading?: boolean;
}

const ProOnboardingCompleteScreen = ({
  handleNext,
  handleBack,
  nextLoading,
}: Props) => {
  return (
    <StyledProPage
      stepNumber={7}
      stepLabel="Finished"
      title="You're Ready 🚀"
      description={
        <>
          <Typography sx={{ fontSize: { xs: 13, md: 18 }, my: 3 }}>
            Pro Tip: creators see <strong>3x success rate</strong> when they
            pitch weekly and send 50+ pitches per week
          </Typography>
        </>
      }
      body={<></>}
      onNext={handleNext}
      onBack={handleBack}
      buttonNext="Start Pitching"
      buttonBack="Back"
      splitScreen={false}
      loading={nextLoading}
    />
  );
};
export default ProOnboardingCompleteScreen;
